<template>
  <div v-if="hasAdminAny">
    <v-row>
      <v-col cols="12"><h1 class="font-weight-thin">Organization Users</h1></v-col>
    </v-row>

    <v-card outlined class="mb-8 mt-5">
      <v-card-text>
        <admin-organization-user-import></admin-organization-user-import>
      </v-card-text>
    </v-card>

    <v-card outlined class="mb-8 mt-5 pa-4">
      <v-card-title @click="toggleList" class="toggleHeader">
        <v-icon small class="mr-3">fas {{ showList ? "fa-chevron-down" : "fa-chevron-right" }}</v-icon>
        <span class="headline font-weight-thin">
          User List (
          <span v-if="loadingList"><v-icon>fas fa-spin fa-spinner</v-icon></span>
          <span v-else>{{ list.length }}</span
          >)</span
        >
      </v-card-title>
      <v-row class="mt-1" v-if="showList">
        <v-col sm="12">
          <v-text-field
            data-cy="organization-user-filter"
            hide-details
            label="Filter Users..."
            outlined
            single-line
            v-model="searchUsers"
            class="mb-2"
          >
            <template v-slot:prepend-inner>
              <v-icon class="mr-2">fas fa-search</v-icon>
            </template>
          </v-text-field>
          <v-card elevation="0">
            <v-data-table
              data-cy="organization-user-table"
              :headers="headerList"
              :hide-default-footer="true"
              :items="userList"
              :search="searchUsers"
              :loading="loadingList"
              disable-pagination
              must-sort
              dense
            >
              <template v-slot:header.userPrincipalName="{ header }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ header.text }}
                      <v-icon
                        small
                        class="mx-1"
                        role="button"
                        tabindex="0"
                        aria-label="More info about User Principal Name"
                        >fas fa-info-circle</v-icon
                      >
                    </span>
                  </template>
                  <span>The UPN ends in "@community-health.org" and is used for login.</span>
                  <br />
                  <span
                    >If you do not see a UPN for an active user that has been imported and needs to log into Continuum,
                    create an ACCS ticket with a Continuum component.</span
                  >
                </v-tooltip>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td>
                    <span role="img" :aria-label="item.active ? 'Active' : 'Inactive'">
                      <v-icon v-if="item.active" small color="primary">far fa-check-circle</v-icon>
                      <v-icon v-else small>fas fa-times</v-icon>
                    </span>
                  </td>
                  <td>{{ item.role }}</td>
                  <td>{{ item.userPrincipalName ? item.userPrincipalName : item.username }}</td>
                  <td>{{ item.displayName }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.dateCreated }}</td>
                  <td class="text-sm-center">
                    <v-btn
                      :data-cy="`edit-icon-${item.username}`"
                      elevation="0"
                      outlined
                      x-small
                      color="primary"
                      @click="showEditForm(item)"
                      >Edit</v-btn
                    >
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <admin-organization-user-edit v-model="showEdit"></admin-organization-user-edit>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import AdminOrganizationUserImport from "./AdminOrganizationUserImport";
import AdminOrganizationUserEdit from "./AdminOrganizationUserEdit";

export default {
  async created() {
    const searchParamList = [
      {
        comparator: "=",
        name: "serviceAreaId",
        value: this.serviceArea,
      },
    ];

    await this.fetchList(searchParamList);
  },
  components: {
    AdminOrganizationUserImport,
    AdminOrganizationUserEdit,
  },
  computed: {
    userList() {
      return this.list.map(user => {
        return {
          ...user,
          displayName: `${user.firstName} ${user.lastName}`,
        };
      });
    },
    ...mapState({
      edit: state => state.admin.user.edit,
      list: state => state.admin.user.list,
      loadingList: state => state.admin.user.loadingList,
      serviceArea: state => state.session.serviceArea,
    }),
    ...mapGetters({
      hasAdminOchin: "session/hasAdminOchin",
      hasAdminAny: "session/hasAdminAny",
    }),
  },
  data() {
    return {
      headerList: [
        {
          text: "Active",
          value: "active",
        },
        {
          text: "Role",
          value: "role",
        },
        {
          text: "User Principal Name (Used for Login)",
          value: "userPrincipalName",
        },
        {
          text: "Name",
          value: "displayName",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Date Created",
          value: "dateCreated",
        },
        {
          sortable: false,
          text: "Edit",
        },
      ],
      searchUsers: null,
      showEdit: false,
      showImport: false,
      showList: true,
    };
  },
  methods: {
    showCreateForm() {
      this.showImport = true;
    },
    showEditForm(user) {
      this.setEdit(Object.assign({}, user));
      this.showEdit = true;
    },
    toggleList() {
      this.showList = !this.showList;
    },
    ...mapActions({
      fetchList: "admin/user/fetchList",
    }),
    ...mapMutations({
      setEdit: "admin/user/setEdit",
    }),
  },
};
</script>

<style scoped>
.toggleHeader {
  cursor: pointer;
}
</style>
